import ImageError from 'assets/png/error/hav_error.png'
import ImageLogo from 'assets/png/error/hav_logo.png'
import { Icon, Page, SlimButton, Typography } from 'components'

import * as S from './styles'

const ErrorElement = () => {
  const reloadPage = () => {
    window.location.reload()
  }

  const toHome = () => {
    window.location.href = '/'
  }

  return (
    <Page hasHeader={false}>
      <S.Wrapper>
        <img alt="Logo Havaianas" src={ImageLogo} />
        <Typography design="hav-h3-text">Erro ao carregar página</Typography>
        <img alt="Erro ao carregar a página" src={ImageError} />
        <S.DescriptionWrapper>
          <Typography design="hav-h4-text">O que pode ter acontecido?</Typography>
          <Typography design="hav-default-01-text">
            Houve um erro inesperado de comunicação e não foi possível carregar as informações da
            página devidamente.
          </Typography>
          <S.ButtonsWrapper>
            <SlimButton
              content="Recarregar página"
              icon={<Icon icon="sync" size="16" />}
              onClick={reloadPage}
              variant="primary"
            />
            <SlimButton
              content="Ir para Página inicial"
              icon={<Icon icon="home-outlined" size="16" />}
              onClick={toHome}
              variant="primary"
            />
          </S.ButtonsWrapper>
        </S.DescriptionWrapper>
      </S.Wrapper>
    </Page>
  )
}

export default ErrorElement
